var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('transition',{attrs:{"name":_vm.transition,"mode":_vm.transitionMode}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }